




















import { Component, Vue } from 'vue-property-decorator';
import MultipleSelectTeam from '@/components/multipleSelectTeam.vue';


@Component({
  components: {
    MultipleSelectTeam,
  },
})
export default class SelectTeamModal extends Vue {
  private visible = false;
  private selectedTeam: string[] = [];

  public showModal() {
    this.visible = true;
  }
  public closeModal() {
    this.visible = false;
    this.selectedTeam = [];
  }
  public handleSubmit() {
    this.$emit('change', this.selectedTeam);
    this.closeModal();
  }
  private onTeamChange(value: string[]) {
    this.selectedTeam = value;
  }
}
